import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    maintSigninContainer: {
      justifyContent: 'space-between',
      alignItems: 'center',
      background: 'transparent',
      padding: '0px 32px 0px 32px',
      minWidth: '100%',
      height: '860px'
    },
    maintSigninInputButtonBlock: {
      width: '842px',
      height: '860px',
      background: 'white',
      color: '#2A2A2A',
      boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
      overflow: 'hidden',
      borderRadius: '8px',
      padding: '0px 64px 0px 64px',
      [theme.breakpoints.down('lg')]: {
        width: '900px',
        padding: '0px 78px 0px 78px',
        height: '1165px'
      },
      [theme.breakpoints.only('lg')]: {
        maxWidth: '50%',
        width: '600px',
        height: '820px',
        padding: '0px 30px 0px 30px'
      }
    },
    maintSigninNumpadBlock: {
      width: '842px',
      height: '860px',
      background: 'white',
      display: 'flex',
      color: '#2A2A2A',
      boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
      borderRadius: '8px',
      alignItems: 'center',
      justifyContent: 'center',
      [theme.breakpoints.down('lg')]: {
        height: '555px',
        width: '900px',
        background: '#F5F6F6',
        boxShadow: 'none',
        borderRadius: '0px'
      },
      [theme.breakpoints.only('lg')]: {
        maxWidth: '50%',
        width: '540px',
        height: '820px',
        boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
        borderRadius: '8px',
        background: 'white'
      },
      '& > * > * > * > * > *': {
        [theme.breakpoints.only('lg')]: {
          width: '140px'
        }
      }
    },
    maintSigninHeading: {
      flex: 'none',
      background: 'transparent',
      margin: '124px 0px 0px 0px',
      [theme.breakpoints.only('lg')]: {
        margin: '85px 0px 0px 0px'
      }
    },
    maintSigninPinInput: {
      flex: 'none',
      background: 'transparent',
      margin: '64px 0px 64px 0px',
      '& > * > * > input': {
        [theme.breakpoints.only('lg')]: {
          minWidth: 'auto'
        }
      }
    }
  })
);
